import store from '@VX/store';
import formatResponseErrors from '@VX/modules/Flash/helpers/formatResponseErrors';

export const errorCodes = () => {
    return store.state.errorCodes;
};

export const getErrorFromResponse = (err, defaultMessage) => {
    // No response key implies a problem with sending the request or a syntax/surrounding js issue
    if (typeof err.response == 'undefined') {
        return $gettext(
            'There was a problem processing your request, please try again.'
        );
    }

    // Server validation errors
    if (typeof err.response.data.errors != 'undefined') {
        return formatResponseErrors(err.response.data.errors);
    }

    let message = defaultMessage || $gettext('Unable to process your request, please try again.');
    let errorData = getErrorType(err.response);

    if (!errorData) {
        return message;
    }

    switch (errorData.type) {
        case 'CREDENTIALS_MISMATCH':
            return $gettext('Invalid credentials, please try again');
    }

    // Include the error code in the message if the response had one
    return `${message} (Error Code: ${errorData.code})`;
};

/**
 * Gets the error code and error type (as defined in ErrorCodes.php) from an ajax request
 * @param  response
 * @return object | false
 */
export const getErrorType = response => {
    if (!response) return;

    let code = response.data.code || response.data.message;

    let error = false;
    Object.keys(errorCodes()).forEach(key => {
        let value = errorCodes()[key];

        if (value == code) {
            error = {
                type: key,
                code: value
            };
        }
    });

    return error;
};



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/error-codes.js